import { render, staticRenderFns } from "./ClassCulture.vue?vue&type=template&id=3e3ba88a&scoped=true&"
import script from "./ClassCulture.vue?vue&type=script&lang=js&"
export * from "./ClassCulture.vue?vue&type=script&lang=js&"
import style0 from "./ClassCulture.vue?vue&type=style&index=0&id=3e3ba88a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3ba88a",
  null
  
)

export default component.exports